export default {
  ASC: "Activité sportive et culturelle",
  ASP: "Activité sportive",
  ACU: "Activité culturelle",
  DEG: "Dégustation",
  LOI: "Equipement de loisir",
  FMA: "Fête et manifestation",
  HLO: "Hébergement locatif",
  LOC: "Meublé et gîte",
  CHO: "Chambre d'hôte",
  HOT: "Hôtel",
  HPA: "Hôtel de plein air",
  ACC: "Aire de camping-car",
  CAM: "Camping",
  ITI: "Itinéraire touristique",
  ORG: "Organisme",
  COM: "Commerce et service",
  ORE: "Réceptif",
  OTI: "Organisme de tourisme instituionnel",
  SIT: "Service d'information touristique privé",
  PCU: "Patrimoine culturel",
  JAR: "Parc et jardin",
  MON: "Site et monument historique",
  MUS: "Musée",
  PNA: "Patrimoine naturel",
  RES: "Restaurant",
  VIL: "Village de vacances",
};